/**
 * Admin-action codes for the admin-action branch of the audit feed. Used as the row `actionCode`
 * (when its category is {@link AuditEventCategory.AdminAction}) and as the `adminActionTypeId`
 * search filter. Mirrors the API `AdminActionType` (persisted `byte` values — do not renumber).
 */
export enum AdminActionType {
  Create = 1,
  Update = 2,
  Deactivate = 3,
  Confirm = 4,
  Deny = 5,
  Assign = 6,
  AddNote = 7,
  Block = 8,
  Restore = 9,
  Revoke = 10,
}
